import React, {useEffect} from 'react';
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {taskAddLocalRequest} from "../store/actions/task.js";
import {dayOffMessageRequest, surveyMessageRequest} from "../store/actions/dayoff.js";

function TaskMessage({message,type="task",text}) {
    const dispatch = useDispatch();
    useEffect(() => {
        if (message && message.message) {
            setTimeout(() => {
                if(type === 'dayoff'){
                    dispatch(dayOffMessageRequest({}))
                }else if(type === 'survey'){
                    dispatch(surveyMessageRequest({}))

                }else{
                    dispatch(taskAddLocalRequest({}))
                }
            }, 5000);
        }
    }, [message,type]);


    const onHide = () => {
        if(type === 'dayoff'){
            dispatch(dayOffMessageRequest({}))
        }else if(type === 'survey'){
            dispatch(surveyMessageRequest({}))
        }else{
            dispatch(taskAddLocalRequest({}))
        }
    }

    return (
        <div className={message?.message ? "task_message show_task" : 'task_message'}>
            <div className="task_header green-top">
                <span>{text?text:"Նոր Առաջադրանք"}</span>
                <i className="fas fa-times" onClick={onHide}/>

            </div>
            <div className="task_body">
                <p>{message?.message}</p>
                {type ==='task'?<p><Link to={`/main_employee/tasks/${message?.task?.id}`}>Դիտել մանրամասները</Link></p>:null}
            </div>
        </div>
    );
}

export default TaskMessage;